import { useState } from "react";
import { inviteUser } from "../../../../scripts/user";
import Button from "../../../UiComponents/Button";
import InputField from "../../../UiComponents/InputField";
import { ButtonRowContainer } from "../../../panel/ModalStyles";
import { SettingsParagraph, SettingsSection } from "../../settingsStyles";
import { loadingStates } from "../../../installation/installationTypes";
import ToggleButton from "../../../UiComponents/ToggleButton";
import Radio from "../../../UiComponents/Radio";
import { TextMuted } from "../../../UiComponents/text/StyledText";
import { ssoProviders } from "../../../../appTypes";
import styled from "styled-components";

const ToggleRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
`

const ProviderRow = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
`

const UserInviteForm = props => {
    const [email, setEmail] = useState();
    const [requireSso, setRequireSso] = useState(false);
    const [allowedProvider, setAllowedProvider] = useState(null);
    const [loadingState, setLoadingState] = useState(loadingStates.NONE);
    const [error, setError] = useState('');

    const handleSendInvite = async () => {
        try {
            setLoadingState(loadingStates.LOADING);
            await inviteUser(
                email,
                props?.venue?.customerId,
                requireSso,
                requireSso && allowedProvider ? [allowedProvider] : null
            );
            await props.refreshWithUpdate();
            setLoadingState(loadingStates.SUCCESS);
        } catch (error) {
            if (error.response?.status === 400) {
                setError('Invalid email. Try again.');
            } else if (error.response?.status === 409) {
                setError(`A user with email address ${email} already has access to this venue.`);
            } else {
                setError('Something went wrong. Try again later.')
            }
            setLoadingState(loadingStates.FAILED);
        } finally {
            if (props.onSubmit) {
                props.onSubmit();
            }
        }
    }

    const handleReset = () => {
        setError('');
        setLoadingState(loadingStates.NONE);
        setEmail('');
        setRequireSso(false);
        setAllowedProvider(null);
        if (props.onReset) {
            props.onReset();
        }
    }

    const handleClose = () => {
        handleReset();
        if (props.onClose) {
            props.onClose();
        }
    }

    return <>
        {loadingState === loadingStates.NONE ? <>
            <SettingsSection>
                <SettingsParagraph>Email</SettingsParagraph>
                <InputField value={email} onChange={(e) => setEmail(e.target.value)} />
            </SettingsSection>

            <SettingsSection>
                <ToggleRow>
                    <ToggleButton checked={requireSso} onToggle={(value) => setRequireSso(value)} />
                    <SettingsParagraph>Require SSO for this user</SettingsParagraph>
                </ToggleRow>
            </SettingsSection>

            {requireSso ? <>
                <SettingsSection>
                    <SettingsParagraph>Allowed provider</SettingsParagraph>
                    <ProviderRow>
                        <Radio name={"ssoProvider"} checked={allowedProvider === null} onChange={() => setAllowedProvider(null)} />
                        <TextMuted>Any SSO provider</TextMuted>
                        {Object.values(ssoProviders).map(provider => <div key={provider.key} style={{ display: 'contents' }}>
                            <Radio name={"ssoProvider"} checked={allowedProvider === provider.key} onChange={() => setAllowedProvider(provider.key)} />
                            <TextMuted>{provider.display} only</TextMuted>
                        </div>)}
                    </ProviderRow>
                </SettingsSection>
            </> : <></>}

            <SettingsSection>
                <ButtonRowContainer>
                    <Button primary onClick={() => handleSendInvite()}>Send invite</Button>
                    <Button secondary onClick={() => handleClose()}>Cancel</Button>
                </ButtonRowContainer>
            </SettingsSection>
        </> : <></>}

        {loadingState === loadingStates.LOADING ? <>
            <SettingsSection>
                <SettingsParagraph>Sending invite link...</SettingsParagraph>
            </SettingsSection>
        </> : <></>}

        {loadingState === loadingStates.SUCCESS ? <>
            <SettingsSection>
                <SettingsParagraph>An invitation has been sent to {email}.</SettingsParagraph>
            </SettingsSection>
        </> : <></>}

        {loadingState === loadingStates.FAILED ? <>
            <SettingsSection>
                <SettingsParagraph>{error}</SettingsParagraph>
            </SettingsSection>
        </> : <></>}

        {loadingState === loadingStates.SUCCESS || loadingState === loadingStates.FAILED ? <>
            <SettingsSection>
                <ButtonRowContainer>
                    <Button primary onClick={() => handleReset()}>{loadingState === loadingStates.SUCCESS ? 'Invite another user' : 'Try again'}</Button>
                    <Button secondary onClick={() => handleClose()}>Cancel</Button>
                </ButtonRowContainer>
            </SettingsSection>
        </> : <></>}
    </>
}

export default UserInviteForm;